<template functional>
    <form-group :label="props.label" :help="props.help"
                :class="[data.staticClass, {'error' : props.v ? props.v.$error : null}]">
        <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   :checked="props.value"
                   v-on:change="($event) => {
                          listeners.input && listeners.input($event.target.checked);
                          if(props.v) {
                               props.v.$touch();
                          }
                          listeners.changed && listeners.changed($event.target.checked);
                        }"
                   id="flexCheckIndeterminate">
            <label class="form-check-label" for="flexCheckIndeterminate">
                {{ props.text }}
            </label>
            <slot></slot>
        </div>
    </form-group>
</template>

<script>
export default {
  name: 'FormInput',
};
</script>
